<template>
<transition name="fade">
<div class="nav-fix" v-show="showFixNav">
  <div class="container">
    <div class="columns is-gapless is-mobile">
      <div class="column">
        <a href="http://tgonetworks.mikecrm.com/81ik65A" target="_blank">
          <img src="@/assets/logo_black.png" alt="" v-if="!isMobile">
          <img src="@/assets/logo_black.png" alt="" v-if="isMobile">
        </a>
      </div>
      <div class="column">
        <a class="button" @click="onApply">申请加入</a>
      </div>
    </div>
  </div>
</div>
</transition>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      scrollY: 0
    }
  },
  computed: {
    showFixNav () {
      return this.scrollY > 400
    },
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  mounted () {
    this.scrollY = window.scrollY
    window.addEventListener('scroll', (e) => {
      this.scrollY = window.scrollY
    })
  },
  props: [],
  components: {},
  methods: {
    onApply () {
      function getParameter (paramName) {
        var searchString = window.location.search.substring(1)
        var i
        var val
        var params = searchString.split('&')

        for (i = 0; i < params.length; i++) {
          val = params[i].split('=')
          if (val[0] === paramName) {
            return val[1]
          }
        }
        return document.referrer ? document.referrer.split('/')[2] : 'none'
      }
      var utmsource = getParameter('utm_source')
      var utmmedium = getParameter('utm_medium')
      if (window.ga) {
        window.ga('send', 'event', 'together', 'apply', utmsource + '/' + utmmedium)
        window.location.href = '/apply'
      }
    }
  }
}
</script>
<style scoped lang="sass">
@import "../../style/bulma/app.sass"

.fade-enter-active, .fade-leave-active
  transition: opacity 0.3s
.fade-enter, .fade-leave-to
  opacity: 0

.nav-fix
  height: 60px
  position: fixed
  z-index: 10
  width: 100%
  top: 0
  left: 0
  background-color: #fff
  border-bottom: 1px solid #e8e8e8
  .container
    width: 80vw
    +mobile
      width: 90vw
    .columns
      align-items: stretch
      justify-content: space-between
      height: 60px
    .column
      display: flex
      align-items: center
      &:first-child
        flex-grow: 0
        // flex-shrink: 0
        flex-basis: auto
        a
          img
            width: 18%
            vertical-align: middle
            +mobile
              width: auto
      &:last-child
        justify-content: flex-end
      a.button
        padding: 0
        width: 110px
        height: 40px
        display: inline-flex
        justify-content: center
        align-items: center
        color: $primary3
        border: 1px solid $primary3
        border-radius: 4px
        font-size: 16px
        font-weight: 700
        &:hover
          opacity: 1
          background-color: $primary3
          color: #fff
      +mobile
        img
          height: 25px
        a
          display: inline-flex
        a.button
          width: 80px
          height: 30px
          display: inline-flex
          justify-content: center
          align-items: center
          // border-radius: 2px
          font-size: 14px
          font-weight: 700
</style>
